import React, { FC }   from "react";
import { useDispatch } from "react-redux";
import UpdatePlan      from "../../../application/usecase/plan/UpdatePlan";
import MenuType        from "../../../domain/menu/MenuType";
import { usePlan }     from "../../../infrastructure/redux/plan/plan";
import BackButton      from "../../components/button/BackButton";
import SaveButton      from "../../components/button/SaveButton";
import Breadcrumbs     from "../../components/common/Breadcrunmbs";
import BottomSection   from "../../components/common/layout/BottomSection";
import TopSection      from "../../components/common/layout/TopSection";
import BaseLayout      from "../../components/layout/BaseLayout";
import PlanForm        from "../../components/plan/PlanForm";

const PlanEditPage: FC = () => {
  const plan = usePlan();

  const updatePlan: UpdatePlan = new UpdatePlan(useDispatch());

  return (
    <>
      <BaseLayout
        menuType={ MenuType.PLAN }
        headerTitle="プラン編集"
      >
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "プラン一覧",
                path: "/plans"
              },
              {
                title: "プラン編集",
                path: "/plan/edit"
              },
            ]
          }/>
        </TopSection>
        <TopSection>
          <BackButton path="/plans"/>
        </TopSection>
        <TopSection>
          <SaveButton
            onClick={ () => updatePlan.execute(plan) }
            label="保存する"
          />
        </TopSection>

        <PlanForm/>

        <BottomSection>
          <SaveButton
            onClick={ () => updatePlan.execute(plan) }
            label="保存する"
          />
        </BottomSection>
        <BottomSection>
          <BackButton path="/plans"/>
        </BottomSection>
      </BaseLayout>
    </>
  );
};

export default PlanEditPage;
